import { NgModule } from '@angular/core';
import { BillingComponent } from './billing.component';
import { BillingInfoComponent } from './components/billing-info/billing-info.component';
import { PaymentMethodComponent } from './components/payment-method/payment-method.component';
import { InvoicesComponent } from './components/invoices/invoices.component';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from '../../environments/environment';
import { MomentModule } from 'ngx-moment';
import { PlansComponent } from './components/plans/plans.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared-module/shared.module';
import { CustomMaterialModule } from '../core/material.module';

@NgModule({
  declarations: [
    BillingComponent,
    BillingInfoComponent,
    PaymentMethodComponent,
    InvoicesComponent,
    PlansComponent,
  ],
  imports: [
    NgxStripeModule.forRoot(
      environment.production
        ? 'pk_live_5uWXjxp7ejs6W9dk85uqU5WC'
        : 'pk_test_LiyHBC0Se59KKkGyAhjCW9ka'
    ),
    MomentModule,
    TranslateModule,
    ReactiveFormsModule,
    CommonModule,
    SharedModule,
    CustomMaterialModule,
  ],
})
export class BillingModule {}
